/**
 * This is default accordion class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
export default class Accordion {
  constructor(elem, APP) {
    this.elem = elem;
    this.triggers = this.elem.querySelectorAll(".js-accordion-trigger");
    this.panels = this.elem.querySelectorAll(".js-accordion-panel");
  }

  /**
   * a11y - tabindex
   */
  updateChildElemsTabIndex() {
    this.panels.forEach((panel) => {
      const focusElements = panel.querySelectorAll("a, button");

      if (panel.classList.contains("expanded")) {
        // Disable the tab index to prevent it from receiving focus by keyboard controls.
        focusElements.forEach((elem) => {
          elem.removeAttribute("tabindex");
        });
      } else {
        // Enable the tab index
        focusElements.forEach((elem) => {
          elem.setAttribute("tabindex", -1);
        });
      }
    });
  }

  /**
   * Clicking an accordion trigger opens/collapses the corresponding panel.
   * @param {number} index
   */
  togglePanel(index) {
    const trigger = this.triggers[index];
    const panel = this.panels[index];
    const panelHeight = `${
      panel.querySelector(".js-accordion-content").offsetHeight
    }px`;
    const targetState = indexPanel.classList.contains("expanded");

    panel.style.height = targetState ? panelHeight : 0;
    panel.setAttribute("aria-hidden", !targetState);
    trigger.setAttribute("aria-expanded", targetState);

    this.updateChildElemsTabIndex();
  }

  /**
   * Clicking an accordion trigger collapses the previously opened panel.
   * @param {number} index
   */
  toggleAllPanels(index) {
    const indexPanel = this.panels[index];
    const panelHeight = `${
      indexPanel.querySelector(".js-accordion-content").offsetHeight
    }px`;
    const targetState = indexPanel.classList.contains("expanded");

    this.panels.forEach((panel, i) => {
      if (i === index && !targetState) {
        panel.style.height = panelHeight;
        panel.setAttribute("aria-hidden", false);
        panel.classList.add("expanded");
        this.triggers[i].classList.remove("fadeout");
        this.triggers[i].setAttribute("aria-expanded", true);
      } else {
        panel.style.height = 0;
        panel.setAttribute("aria-hidden", true);
        panel.classList.remove("expanded");
        this.triggers[i].classList.add("fadeout");
        this.triggers[i].setAttribute("aria-expanded", false);
      }
    });

    this.updateChildElemsTabIndex();
  }

  /**
   * Set the accordion trigger click handler
   */
  setTriggerHandler() {
    this.triggers.forEach((t, i) => {
      t.addEventListener("click", () => {
        this.toggleAllPanels(i);
      });
    });
  }

  /**
   * Resizing the window updates the opened accordion panel height.
   */
  resizePanel() {
    this.panels.forEach((elem) => {
      const targetHeight = elem.querySelector("div").offsetHeight + "px";
      elem.style.height = elem.classList.contains("expanded")
        ? targetHeight
        : "0";
    });
  }

  init() {
    this.setTriggerHandler();

    // open first accordion on the page load
    if (this.elem.dataset.openFirst) {
      this.toggleAllPanels(0);
    } else {
      this.updateChildElemsTabIndex();
    }

    window.addEventListener("resize", () => {
      this.resizePanel();
    });
  }
}
